{
  "version": 1,
  "asset_id": "607dfd35-9e69-451e-9945-28d1cf80599b",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/607dfd35-9e69-451e-9945-28d1cf80599b/hiatal-type-iv-patient-before-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/607dfd35-9e69-451e-9945-28d1cf80599b/hiatal-type-iv-patient-before-480.webp",
  "original_filename": "hiatal-type-iv-patient-before-480.webp",
  "size": 28624,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:39Z"
}
